/*
 * Page Mentions legales : editeur, hebergement, propriete intellectuelle,
 * responsabilite et contact. Les elements a completer avant le lancement
 * public sont signales visuellement (SIRET, adresse, hebergeur definitif).
 * Regle editoriale : aucun tiret dans les textes.
 */

import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Scale, TriangleAlert } from "lucide-react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

const SECTIONS = [
  {
    key: "editeur",
    title: "Éditeur du site",
    content:
      "Ce site et le diagnostic CYCLIQ sont édités par la société TROPIC SPOR'ATTITUD CARAIBES (T.S.A 972), SASU, immatriculée sous le numéro SIRET 819 898 453 00017, dont le siège social est situé Quartier Baie des Tourelles, 95 rue J Baptiste Rouam Sim, 97200 Fort de France, Martinique, France. Directeur de la publication : Gino Fidelin, éducateur sportif, fondateur de Gino Body & Soul. Email : contact@ginobodyandsoul.com.",
    needsValidation: false,
  },
  {
    key: "hebergement",
    title: "Hébergement",
    content:
      "L'application est hébergée par la plateforme Emergent (emergent.sh). L'envoi des emails s'appuie sur Brevo, prestataire français hébergé dans l'Union européenne. La gestion commerciale s'appuie sur GoHighLevel.",
    needsValidation: true,
    validationNote: "À vérifier après le déploiement définitif : raison sociale et adresse complète de l'hébergeur.",
  },
  {
    key: "propriete",
    title: "Propriété intellectuelle",
    content:
      "L'ensemble des contenus de ce site (textes, questionnaire, méthode CYCLIQ, logo, identité visuelle) est la propriété exclusive de Gino Body & Soul. Toute reproduction, diffusion ou utilisation sans autorisation écrite préalable est interdite.",
    needsValidation: false,
  },
  {
    key: "responsabilite",
    title: "Responsabilité",
    content:
      "Le diagnostic CYCLIQ est un outil d'orientation et d'éducation. Il ne constitue pas un diagnostic médical et ne remplace pas l'avis d'un professionnel de santé. Les résultats sont calculés localement dans le navigateur à partir des réponses fournies et ne font l'objet d'aucune conservation par nos serveurs.",
    needsValidation: false,
  },
  {
    key: "donnees",
    title: "Données personnelles",
    content:
      "Le traitement des données est décrit en détail dans la politique de confidentialité, notamment le principe de conservation nulle des données de santé.",
    needsValidation: false,
    privacyLink: true,
  },
  {
    key: "contact",
    title: "Contact",
    content:
      "Pour toute question relative au site, à la méthode CYCLIQ ou à vos données : contact@ginobodyandsoul.com.",
    needsValidation: false,
  },
];

export default function LegalPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 max-w-[760px] w-full mx-auto px-4 sm:px-6 py-14">
        <div className="flex items-center gap-2 text-[#235277]">
          <Scale className="w-5 h-5" aria-hidden="true" />
          <span className="text-xs font-semibold tracking-[0.15em] uppercase">Informations légales</span>
        </div>
        <h1
          className="font-heading mt-3 text-3xl sm:text-4xl font-semibold tracking-tight text-[#060606]"
          data-testid="legal-page-title"
        >
          Mentions légales
        </h1>

        <div className="mt-10 space-y-8">
          {SECTIONS.map((section) => (
            <section key={section.key} data-testid={`legal-section-${section.key}`}>
              <h2 className="font-heading text-lg font-semibold text-[#060606]">{section.title}</h2>
              <p className="mt-2 text-sm leading-relaxed text-[#333333]">
                {section.content}
                {section.privacyLink && (
                  <>
                    {" "}
                    <Link
                      to="/confidentialite"
                      data-testid="legal-privacy-link"
                      className="underline underline-offset-2 text-[#235277]"
                    >
                      Consulter la politique de confidentialité
                    </Link>
                  </>
                )}
              </p>
              {section.needsValidation && (
                <div
                  className="mt-3 flex items-start gap-2 rounded-xl bg-[#FDF6E7] border border-[rgba(94,85,21,0.25)] px-3 py-2"
                  data-testid={`legal-validation-${section.key}`}
                >
                  <TriangleAlert className="w-3.5 h-3.5 shrink-0 mt-0.5 text-[#5E5515]" aria-hidden="true" />
                  <p className="text-[11px] leading-relaxed text-[#5E5515]">{section.validationNote}</p>
                </div>
              )}
            </section>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
